<template>
  <div :class="'help-box ' + pos">
    <h3>{{ data.Header }}</h3>
    <p class="text-uppercase mb-1 pb-2">
      <span>{{ data.Txt }}</span>
      <DoPhoneLink :value="data" />
    </p>
  </div>
</template>
<script>
  export default {
    props: {
      data: {
        type: Object,
      },
      pos: {
        type: String,
      },
    },
  };
</script>
<style lang="scss" scoped>
  span {
    display: block;
  }
  p {
    font-size: 14px;
  }
</style>
